export enum ConversionErrorType {
  DelimiterError = 'DelimiterError',
}
